<template>
  <div
    class="modal-loading d-flex justify-content-center align-items-center"
  >
    <img :src="spinnerUrl" alt="Loading Spinner" />
  </div>
</template>

<script>
export default {
  name: "modal-loading",
  props: {
    minHeight: {
      type: String,
    }
  },
  data() {
    return {
      spinnerUrl: HH_COMPONENTS_URL + "/spinner.svg"
    };
  }
};
</script>

<style scoped>
.modal-loading {
  min-height: 300px;
}
.modal-loading img {
  height: 100px;
}
.loading-overlay img:-moz-loading {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/modals/ModalLoading.vue